import { getSession as getSessionData } from "@api";
import { State } from "@store";
import { ThunkAction } from "redux-thunk";
import { ActionType } from "../types";
import { Session, SessionAction } from "../types/session";

export function getSessionSuccess(session: Session): SessionAction {
  return {
    type: ActionType.GET_SESSION_SUCCESS,
    data: session,
  };
}

export function getSessionFailure(): SessionAction {
  return {
    type: ActionType.GET_SESSION_FAILURE,
  };
}

export function getSession(): ThunkAction<void, State, unknown, SessionAction> {
  return async (dispatch) => {
    try {
      const session = await getSessionData();
      dispatch(getSessionSuccess(session));
    } catch (error) {
      dispatch(getSessionFailure());
    }
  };
}
